import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_PARCEL_SERVICE_TYPES,
  GET_PARCEL_SERVICE_TYPES,
  CLEAR_PARCEL_SERVICE_TYPE,
  CLEAR_PARCEL_SERVICE_TYPES,
  FLAG_PARCEL_SERVICE_TYPE_ACTIVITY,
  GET_PARCEL_SERVICE_TYPE,
} from '../../../actions/types/cargo/ParcelServiceType';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_PARCEL_SERVICE_TYPES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_PARCEL_SERVICE_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_PARCEL_SERVICE_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PARCEL_SERVICE_TYPE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PARCEL_SERVICE_TYPE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_PARCEL_SERVICE_TYPE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
